import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[nexusUnDecimal]'
})
export class UnDecimalDirective {

  private regex: RegExp = new RegExp(/^\d*\.?\d{0,1}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(
    private el :ElementRef
  ) { }

  @HostListener('keydown', ['$event'])

  onkey(event: KeyboardEvent) {
    console.log(this.el.nativeElement.value)
    if (this.specialKeys.indexOf(event.key)!== -1) {
      return
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault()
    }
  }
}
